module.exports = __webpack_public_path__ + "img/avatar-s-2.782ad369.jpg";